import { EContractorPaymentStatus } from "../../contractor-payments";
import { schemes, zSchema } from "../../schema-validation";
import { EContractorDisbursementMethod } from "../../workers-shared";
import { EWebhookType } from "../EWebhookType";

export const contractorPaymentWebhookSchema = zSchema.object({
  /**
   * @deprecated Use `totals.gross_amount` and `totals.net_amount` instead. This field is maintained for backward compatibility.
   * For payments with `has_payment_items: true`, use `totals.gross_amount` for gross amount or `totals.net_amount` for net amount.
   */
  amount: zSchema.number().nullish(),
  approval_required: zSchema.boolean(),
  approved: zSchema.boolean(),
  companyID: schemes.companyID(),
  contractorID: schemes.mongoObjectId(),
  contractorPaymentID: schemes.mongoObjectId(),
  disbursement: zSchema.object({
    method: zSchema.nativeEnum(EContractorDisbursementMethod),
    history: zSchema
      .array(
        zSchema.object({
          date: zSchema.string(),
          status: zSchema.string(),
        })
      )
      .default([]),
    status: zSchema.string(),
  }),
  first_name: zSchema.string(),
  has_payment_items: zSchema.boolean(),
  last_name: zSchema.string(),
  metadata: schemes.metadata(),
  middle_name: zSchema.string().nullable(),
  pay_date: schemes.isoDate(),
  status: zSchema.nativeEnum(EContractorPaymentStatus),
  test: zSchema.boolean(),
  timestamp: zSchema.string(),
  type: zSchema.nativeEnum(EWebhookType),
  totals: zSchema.object({
    company_cash_requirement: zSchema.number().nullish(),
    company_debit: zSchema.number().nullish(),
    gross_amount: zSchema.number().nullish(),
    net_amount: zSchema.number().nullish(),
    deductions: zSchema.number().nullish(),
  }),
});

export type TContractorPaymentWebhook = zSchema.infer<
  typeof contractorPaymentWebhookSchema
>;
